import { LocaleDropdown } from 'components/localeDropdown/localeDropdown.module';
import { ENGT_CHAT } from 'js/bot.model';

import './launchHeader.scss';

export const LaunchHeaderTemplate = (model) => {
	const { description, title } = model || {};

	const renderLocaleDropdown = () => {
		if (ENGT_CHAT.get('config.isMultilingualEnabled')) {
			return new LocaleDropdown().render();
		}
		return '';
	};

	const descriptionTag = `<span id="botDescription" class="engt-launcher-description">${description}</span>`;

	/* html */
	const html = `
		<div class="engt-launcher-header-top">
			<header-icon></header-icon>
			<div class="header-option-wrap">
				${renderLocaleDropdown()}
				<header-options></header-options>
			</div>
		</div>
		<header-title></header-title>
		${descriptionTag}
		<start-conversation></start-conversation>
    `;

	return html;
};
